import styled from "@emotion/styled";
import theme from "theme";

// Styled Components
const Container = styled.div``;

const TableContainer = styled.div`
  background-color: white;
  border-radius: 2px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
`;

const TableWrapper = styled.div`
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHeader = styled.thead`
  tr {
    background-color: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
  }
`;

const HeaderCell = styled.th`
  text-align: ${(props) => props.$align || "center"};
  padding: 1rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const TableBody = styled.tbody`
  tr {
    border-bottom: 1px solid #f3f4f6;
  }
`;

const TableCell = styled.td`
  padding: 0.75rem 1.5rem;
  font-size: 0.875rem;
  color: #4b5563;
`;

const Checkbox = styled.input`
  height: 1rem;
  width: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #d1d5db;
`;

const Labell = styled.span`
  margin-left: 0.5rem;
  font-size: 0.875rem;
  color: #4b5563;
`;

const Label = styled.div`
  display: flex;
  text-align: left;
  flex: 0.2;
  font-family: "Charlie Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;
`;

const Astrik = styled.span`
  color: red;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 15px 8px 15px;
  margin: 0px 0px 10px 0px;
`;

const Children = styled.div`
  flex: 1.3;
`;

const Wrapper = styled.div`
  display: flex;
  padding: 0px;
`;
const SC = {
  Container,
  TableContainer,
  TableWrapper,
  Table,
  TableHeader,
  HeaderCell,
  HeaderContent,
  TableBody,
  TableCell,
  Checkbox,
  Label,
  Labell,
  Astrik,
  LabelContainer,
  Children,
  Wrapper,
};

export default SC;
